import { render, staticRenderFns } from "./TreatmentPlanRequest.vue?vue&type=template&id=3a521b70&"
import script from "./TreatmentPlanRequest.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequest.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequest.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports